// extracted by mini-css-extract-plugin
export default {"servicedDevicePageTitle":"ServicedDevicesPage_servicedDevicePageTitle__aQFHG","stickyDeviceListHeader":"ServicedDevicesPage_stickyDeviceListHeader__uTpVv"};